
import React from "react";
import PointDisplay from "./scoring/PointDisplay";
import PuttingHelp from "./scoring/PuttingHelp";
import ScoringButtonsRenderer from "./scoring/ScoringButtonsRenderer";
import CancelButton from "./scoring/CancelButton";
import { getScorePoint, getFirstPointForTest } from "./scoring/pointMapping";
import { 
  isPuttingTest,
  isChippingTest,
  isWedgingTest,
  isBunkerTest,
  isIronTest,
  isFairwayWoodTest,
  isDriverTest,
  isGreenAttackTest
} from "../level3/scoring/utils";

interface ScoringPanelProps {
  testId: string | null;
  currentPoint: string;
  currentAttempt: number;
  maxAttempts: number;
  distance: string;
  onScoreChange: (score: number, tendency?: any) => void;
  onCancelLastEntry: () => void;
  isChippingTest: boolean;
  currentLevel?: 1 | 2 | 3;
}

const ScoringPanel: React.FC<ScoringPanelProps> = ({
  testId,
  currentPoint,
  currentAttempt,
  maxAttempts,
  distance,
  onScoreChange,
  onCancelLastEntry,
  isChippingTest: propIsChippingTest,
  currentLevel = 1
}) => {
  const isPutting = testId ? isPuttingTest(testId) : false;
  const isChipping = testId ? isChippingTest(testId) : false;
  const isWedging = testId ? isWedgingTest(testId) : false;
  const isBunker = testId ? isBunkerTest(testId) : false;
  const isIron = testId ? isIronTest(testId) : false;
  const isFairwayWood = testId ? isFairwayWoodTest(testId) : false;
  const isDriver = testId ? isDriverTest(testId) : false;
  const isGreenAttack = testId ? isGreenAttackTest(testId) : false;

  console.log("ScoringPanel - testId:", testId, "isPutting:", isPutting, "isChipping:", isChipping, "currentPoint:", currentPoint);

  // Utiliser cette fonction pour déterminer le point à utiliser pour l'enregistrement du score
  const handleScoreChange = (score: number, tendency?: any) => {
    const scorePoint = getScorePoint(currentPoint, testId, currentLevel);
    console.log(`Mapping point ${currentPoint} to score point ${scorePoint}`);
    onScoreChange(score, tendency);
  };

  const firstPoint = getFirstPointForTest(testId);

  return (
    <div className="bg-white/95 rounded-md shadow-sm p-4 border border-gray-200">
      <PointDisplay 
        currentPoint={currentPoint}
        currentAttempt={currentAttempt}
        maxAttempts={maxAttempts}
        distance={distance}
        isChippingTest={propIsChippingTest || isChipping}
        getFormattedPoint={(point: string) => `Point ${point}`}
        currentLevel={currentLevel}
      />

      {isPutting && <PuttingHelp />}

      <div className="grid grid-cols-1 gap-2 mb-4">
        <ScoringButtonsRenderer
          isPutting={isPutting}
          isChipping={isChipping}
          isWedging={isWedging}
          isBunker={isBunker}
          isIron={isIron}
          isFairwayWood={isFairwayWood}
          isDriver={isDriver}
          isGreenAttack={isGreenAttack}
          currentLevel={currentLevel}
          currentPoint={currentPoint}
          onScoreChange={handleScoreChange}
          testId={testId || undefined}
        />
        <CancelButton
          onCancelLastEntry={onCancelLastEntry}
          currentPoint={currentPoint}
          currentAttempt={currentAttempt}
          firstPoint={firstPoint}
        />
      </div>
    </div>
  );
};

export default ScoringPanel;
